import * as React from 'react';
import { getApiUrl } from '../../../config/api';
import { Box, TextField, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function TextSearch(props) {
    const [query, setQuery] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleSearch = async () => {
        if (!query.trim()) {
            return;
        }

        setLoading(true);
        props.threadsLoadingCallback && props.threadsLoadingCallback();

        try {
            const response = await fetch(getApiUrl('/v1/messages/text_search/search'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: query.trim() })
            });

            if (response.ok) {
                const result = await response.json();
                // Pass the raw search results directly
                props.threadsCallback && props.threadsCallback(result);
            } else {
                console.error('Search failed:', response.status);
                props.threadsCallback && props.threadsCallback({ data: [] });
            }
        } catch (error) {
            console.error('Search error:', error);
            props.threadsCallback && props.threadsCallback({ data: [] });
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            alignItems: 'center',
            p: 1,
            bgcolor: 'background.paper',
            borderRadius: 1,
        }}>
            <TextField
                label="Search message content"
                variant="outlined"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
                sx={{ flexGrow: 1 }}
                placeholder="Enter text to search for in messages..."
            />
            <Button
                variant="contained"
                onClick={handleSearch}
                disabled={loading || !query.trim()}
                startIcon={<SearchIcon />}
            >
                {loading ? 'Searching...' : 'Search'}
            </Button>
        </Box>
    );
}